<template>
    <v-container class="pa-2" fluid grid-list-sm >   
        <v-layout row wrap v-if="content">
            <v-flex xs6 offset-3> 
                <v-card>
                <v-card-title>                    
                    {{content.title}}
                </v-card-title>
                <v-card-text>
                    <div >
                        <v-layout row wrap justify-center>              
                            
                            <v-flex v-for="(chapter, index) in content.chapter_list" v-bind:key="chapter.chapter_id" shrink :xs12="index % 3 == 0" :xs6="index % 3 != 0" @click = "goToChapter(chapter)">
                                <v-layout justify-center>
                                    <v-progress-circular
                                        :rotate="270"
                                        :size="150"
                                        :width="10 * (describer[index].tasks_exists)"
                                        :value="describer[index].progress_tasks"
                                        :color="getProgressColor(describer[index].progress_tasks)" 
                                        background-color="red"
                                        
                                        >
                                    <v-progress-circular
                                        :rotate="270"
                                        :size="135"
                                        :width="10 * (describer[index].programs_exists)"
                                        :value="describer[index].progress_programs"
                                        :color="getProgressColor(describer[index].progress_programs)"                                        
                                        >
                                        <v-img :src="chapter.chapter_icon" width="80px" height="80px" alt="" contain>
                                        </v-img>
                                    </v-progress-circular>
                                            <v-icon v-if="!describer[index].active" class="access-icon" color="red">block</v-icon>                                    
                                            <v-icon v-if="describer[index].active" class="access-icon" color="green">forward</v-icon>                                    
                                    </v-progress-circular>

                                    
                                    
                                 </v-layout>

                                <v-layout justify-center>
                                    <h2 center >{{chapter.chapter_name}}</h2>

                                </v-layout>
                        </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs3>
            <v-card>
                <v-card-text>
                <v-layout row justify-center>
                    <v-btn block color=primary @click="continueCourse()">Start/continue</v-btn>
                    <p></p>
                    <v-btn block color=primary @click.prevent="resetCourse('refresh')">Reset/refresh course</v-btn>
                    <p></p>
                    <v-btn block color=primary @click="resetCourse('logout')">Logout from course</v-btn>
                </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {
            content : null,
            populate: -1,
            chapterIndex: -1,
            lessonRead: false,
            describer: []
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    
            this.$store.commit('setBcChange',true)

            // get category list
            axios.get('/get-active-chapters/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.content = res.data 
                    this.countProgress()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        resetCourse(t) {            
            this.$store.commit('setFeedback', null)    
            const data = { type: t }

            // get category list
            axios.post('/service-refresh-course/' + this.$route.params.id, data, this.$store.getters.getAxiosConfig)
                .then(() => {
                    // open course
                        this.$router.push({name:'courses', params: {id: JSON.parse(localStorage.getItem('position')).activeArea.id }})   
                    ///////////////////////////////////////////////////////////////////////
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },        
        continueCourse() {
            // open from last position by last task
        },
        getColor(index) {
            if (index == 0) return 'green'
            const c = this.content.chapter_list[index-1]           
            if ((c.programs_finished + c.tasks_finished) > (c.programs_nonfinished + c.tasks_nonfinished)) return 'green'
            return 'yellow'
        },
/*        startLesson(chapter_id, lesson_id) {
            this.$router.push({name:'chapter_content', params: {id: JSON.parse(localStorage.getItem('position')).activeCourse.id}})

        },
*/        countProgress() {
            // count progress
            var perc_t = 0
            var perc_p = 0
            var task_exists = 0
            var program_exists = 0
            var all_tasks = 0
            var all_programs
            var act = true
            this.describer = []
            for(let i = 0; i < this.content.chapter_list.length; i++ ) {
                all_tasks = this.content.chapter_list[i].tasks_finished + this.content.chapter_list[i].tasks_nonfinished
                all_programs = this.content.chapter_list[i].programs_finished + this.content.chapter_list[i].programs_nonfinished
                task_exists = 0
                program_exists = 0
                if (all_tasks > 0) {
                    perc_t = Math.floor(0.5 + 100 * this.content.chapter_list[i].tasks_finished / all_tasks)
                    task_exists = 1
                }
                if (all_programs > 0) {
                    perc_p = Math.floor(0.5 + 100 * this.content.chapter_list[i].programs_finished / all_programs)
                    program_exists = 1                        
                }
                if (i > 0) {
                    let sum = this.describer[i-1].progress_tasks + this.describer[i-1].progress_programs
                    act = false
                    if (sum > 100) act = true
                    else if (sum > 50 && (!this.describer[i-1].tasks_exists || !this.describer[i-1].programs_exists)) act = true
                }
                this.describer.push({
                        progress_tasks : perc_t,
                        tasks_exists : task_exists,
                        progress_programs : perc_p,
                        programs_exists : program_exists,
                        active: act
                })                
            }
        },
        goToChapter(chapter) {
            this.$store.dispatch('setActiveChapter',{id:chapter.chapter_id, name: chapter.chapter_name});
            this.$router.push({name:'chapter_content', params: {id: chapter.chapter_id}})   
        },
        getProgressColor(value) {
            if (value > 50) return "light-green lighten-1"
            if (value > 25) return "light-green lighten-3"
            return "lime lighten-3"
        }
    }
}
</script>


<style>
.access-icon {
  position: absolute;
  bottom: 1px;
  right: 1px;
  cursor: pointer;
}

</style>
